import { SettingsSection } from './SettingsSection';
import { SettingsKeys, SettingsTranslationKeys, TimeTranslationKeys } from '../../../api/models/TranslationKeys';
import { Log } from '@lightningjs/sdk';
import { ScrollList } from '../../../components/shared/ScrollList';
import { CustomerSettingsKeys } from '../../../api/models/CustomerSettingsKeys';
import { GlobalSettingsKeys } from '../../../api/models/GlobalSettingsKeys';
import { SettingsOptionButton } from '../components/SettingsOptionButton';
import { Backend } from '../../../api/Backend';

export class PlayerSection extends SettingsSection {
  constructor(backend: Backend) {
    super(backend, backend.translations.forKey(SettingsTranslationKeys.settings_title_player));
  }

  override addControls(list: ScrollList) {
    if (!this.backend.globalSettings.boolValue(SettingsKeys.restartLinearStreams)) {
      return;
    }
    super.addControls(list);
    const linearElement = this.addLinearStreamTimeElememt(list);
    this.addLinearStreamTimeData(linearElement);
  }

  addLinearStreamTimeElememt(list: ScrollList) {
    return list.items.childList.a({
      type: SettingsOptionButton,
      data: {
        label: this.backend.translations.forKey(SettingsTranslationKeys.settings_player_linear_session_max_duration),
        options: [],
        value: null,
      },
      passSignals: {
        onActivate: true,
      },
    });
  }

  private addLinearStreamTimeData(element: SettingsOptionButton) {
    this.backend.cachedCustomerSettings
      .getSetting(this.backend, CustomerSettingsKeys.max_linear_stream_time)
      .then(res => {
        if (res && res.value) {
          return +res.value;
        }
        return undefined;
      })
      .catch(err => {
        Log.error(err);
        return undefined;
      })
      .then((currentSetting: number | undefined) => {
        let selectedValue: string | undefined;
        if (currentSetting) {
          selectedValue = Math.round(currentSetting / 3600).toString();
        } else {
          const defaultStreamTime =
            this.backend.globalSettings.numberValue(GlobalSettingsKeys.defaultMaxLinearStreamTime) || 14400000;
          selectedValue = Math.round(defaultStreamTime / 3.6e6).toString();
        }

        const selectedOption = {
          text: this.backend.translations
            .forKey(TimeTranslationKeys.time_duration_hours)
            .replace('$1', selectedValue.toString()),
          value: +selectedValue * 3600,
        };

        const streamTimeOptions = this.backend.globalSettings
          .stringArray(GlobalSettingsKeys.maxLinearStreamTimeOptions)
          ?.map(el => {
            return {
              text: this.backend.translations
                .forKey(TimeTranslationKeys.time_duration_hours)
                .replace('$1', el.toString()),
              value: +el * 3600,
            };
          });

        element.data = {
          label: this.backend.translations.forKey(SettingsTranslationKeys.settings_player_linear_session_max_duration),
          options: streamTimeOptions,
          value: selectedOption,
          action: ctrl => {
            this.backend.cachedCustomerSettings.setSetting(
              this.backend,
              CustomerSettingsKeys.max_linear_stream_time,
              ctrl.data.value.value
            );
          },
        };
      });
  }
}
